import { LookupModelSearchEvent } from "@mcleod/components";
import {
    AutogenLayoutTrailerContinuityReport
} from "./autogen/AutogenLayoutTrailerContinuityReport";

export class TrailerContinuityReport extends AutogenLayoutTrailerContinuityReport {
    override onLoad(): void | Promise<void> {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxTrailerStatus.selectedItem = this.textboxTrailerStatus.items[0];
        this.textboxDriverType.selectedItem = this.textboxDriverType.items[0];
    }

    excludabletextboxFTextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_trailer = "Y"
    }
}
